import { render, staticRenderFns } from "./ServicesAndPrices.vue?vue&type=template&id=20722fe1"
import script from "./ServicesAndPrices.vue?vue&type=script&lang=js"
export * from "./ServicesAndPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports